<template>
  <span v-if="payment_method && payment_method.brand" :class="classes">
     <img :src="payment_method.cc_image_url" width="25" :alt="payment_method.brand"/> ending in {{ payment_method.last4 }}
  </span>
  <span v-else-if="payment_method && payment_method.bank_name" :class="classes">
    {{ payment_method.bank_name }} ending in {{ payment_method.last4 }}
  </span>
</template>

<script>
  export default {
    props: {
      payment_method: Object,
      classes: String,
    },
  }
</script>